import {Flex, TabMenuItem, TabsMenu, TabsSkinEnum} from '@priority-software/priority-style-react';
import React, {FC, useMemo, useRef, useState} from 'react';
import {SideBar} from './SideBar';
import {RichText} from './RichText';
import {useEmailContext} from '../context';
import {getLanguageTabs} from '../../Automations/components/RuleDialog/parts/AutomationActionToolbar/utils';
import {ETargetAutoFill} from './RichText/types';
import {createDataTestId} from '../../../utils/dataTestId';
import {AILoader} from '../../../components/AILoader';
import styles from './styles.module.scss';
import {getBasicLanguage} from '../../../_shared/GWTBridge/invoke/common';
import {
    ENGLISH_INSTALLATION_LANGUAGE,
    HEBREW_INSTALLATION_LANGUAGE
} from '../../Automations/components/RuleDialog/parts/AutomationActionToolbar/constants';

export const BodyEmailEditor: FC = () => {
    const {
        states,
        handlers: {updateLanguage, updateEmailHTML}
    } = useEmailContext();
    const {language, aiLoading} = states;
    const [activeTab, setActiveTab] = useState(language);

    const languageTabs = useMemo(getLanguageTabs, []);
    const basicLanguage = getBasicLanguage(); // system installation language
    // show english and hebrew tabs in English environment if there are messages in hebrew language (EP-54683)
    const shouldShowTabs =
        states?.templates[HEBREW_INSTALLATION_LANGUAGE]?.editorSubject?.length > 0 ||
        states?.templates[HEBREW_INSTALLATION_LANGUAGE]?.emailHtml?.length > 0;

    const tabs = useMemo(
        () =>
            languageTabs.map((tab: {id: string; title: string; lang: string}) => (
                <TabMenuItem
                    {...createDataTestId(`email-tab-${tab.lang}`, true)}
                    key={tab.id}
                    onTabClick={async () => {
                        if (activeTab === tab.id) return;
                        await updateEmailHTML();
                        setActiveTab(tab.id);
                        updateLanguage(tab.id);
                    }}
                    isActive={activeTab === tab.id}
                    text={tab.title}
                    id={tab.id}
                />
            )),
        [activeTab, states.emailEditor]
    );

    const targetAutoFill = useRef(ETargetAutoFill.EDITOR);
    const subjectInputRef = useRef<HTMLInputElement>(null);

    const messageCursorLastPosition = useRef<number>(
        states.templates[states.language]?.editorSubject?.length || ''
    );

    const props = {
        messageCursorLastPosition,
        subjectInputRef,
        targetAutoFill
    };

    return (
        <Flex direction="column" componentClasses={styles.containerGap}>
            {(basicLanguage !== ENGLISH_INSTALLATION_LANGUAGE || shouldShowTabs) && (
                <TabsMenu skin={TabsSkinEnum.folder}>{tabs}</TabsMenu>
            )}
            <Flex componentClasses={styles.containerGap}>
                <SideBar {...props} />
                <RichText {...props} />
            </Flex>

            {aiLoading ? (
                <div className={styles.aiLoaderBackdrop}>
                    <Flex direction={'column'} alignItems="center" justifyContent="center">
                        <AILoader />
                    </Flex>
                </div>
            ) : null}
        </Flex>
    );
};
